import { TooltipRenderProps } from 'react-joyride';
import { X } from 'lucide-react';

export const TourTooltip = ({
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    isLastStep,
    size
}: TooltipRenderProps) => (
    <div
        {...tooltipProps}
        className="bg-white dark:bg-zinc-900 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 dark:border-zinc-800 max-w-xs md:max-w-md overflow-hidden flex flex-col items-start text-left z-50"
    >
        <div className="p-5 md:p-6 w-full relative">
            {/* Close Button */}
            <button
                {...closeProps}
                className="absolute top-4 right-4 p-1 rounded-full text-gray-400 hover:bg-gray-100 dark:hover:bg-zinc-800 transition-colors"
            >
                <X className="w-4 h-4" />
            </button>

            {/* Header */}
            <div className="mb-2 flex items-center gap-2">
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-bold">
                    {index + 1}
                </span>
                {step.title && (
                    <h4 className="font-bold text-lg text-gray-900 dark:text-white">
                        {step.title}
                    </h4>
                )}
            </div>

            {/* Content */}
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed ml-8">
                {step.content}
            </p>
        </div>

        {/* Footer */}
        <div className="w-full bg-gray-50/50 dark:bg-zinc-800/30 p-4 border-t border-gray-100 dark:border-zinc-800 flex items-center justify-between">
            <div className="flex items-center gap-1">
                {/* Dots indicator */}
                {Array.from({ length: size }).map((_, i) => (
                    <div
                        key={i}
                        className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-4 bg-primary' : 'w-1.5 bg-gray-300 dark:bg-zinc-700'}`}
                    />
                ))}
            </div>

            <div className="flex items-center gap-3">
                {index > 0 && (
                    <button
                        {...backProps}
                        className="text-sm font-semibold text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white px-3 py-2 transition-colors"
                    >
                        Back
                    </button>
                )}
                <button
                    {...primaryProps}
                    className="text-sm font-bold bg-primary hover:bg-primary/90 text-white px-5 py-2 rounded-xl shadow-lg shadow-primary/20 hover:shadow-primary/30 active:scale-95 transition-all text-center min-w-[80px]"
                >
                    {isLastStep ? 'Finish' : 'Next'}
                </button>
            </div>
        </div>
    </div>
);
